// extracted by mini-css-extract-plugin
module.exports = {"chat-kb-search":"chat-kb-search__1a2Gk2tdP7zC"};